import { render, staticRenderFns } from "./rechargeKuai.vue?vue&type=template&id=672584d8&scoped=true"
import script from "./rechargeKuai.vue?vue&type=script&lang=js"
export * from "./rechargeKuai.vue?vue&type=script&lang=js"
import style0 from "./rechargeKuai.vue?vue&type=style&index=0&id=672584d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672584d8",
  null
  
)

export default component.exports